export default __webpack_public_path__ + "static/media/about_bg.c5ab8f7b.png";